export default __webpack_public_path__ + "static/media/img-01.6286eb45.png";